export type GenerationFailedKind = 'image' | 'audio'

export interface GenerationFailedCopyProps {
  kind: GenerationFailedKind
  /** `metadata.generationError.reason` as read by `getGenerationError` — any string, known or not */
  reason: string
  /** The viewer is the account that asked for the generation, so "your AI tokens" is true for them */
  requestedByMe: boolean
}

/** Wording from docs/ai-language.md: "AI image" → mood sketch, "AI music" → demo track */
export const generationFailedTitles: Record<GenerationFailedKind, string> = {
  image: 'Mood sketch not made',
  audio: 'Demo track not made',
}

const ownAlternative: Record<GenerationFailedKind, string> = {
  image: 'add your own image',
  audio: 'record or upload your own audio',
}

/**
 * The one message per (reason, viewer) pair. Never the server's text, and never "this month":
 * the quota has no reset. A reason this build does not know gets the generic line.
 */
export const generationFailedCopy = ({ kind, reason, requestedByMe }: GenerationFailedCopyProps): string => {
  if (reason === 'quota-exceeded') {
    return requestedByMe
      ? `You've used all your AI tokens, so Tunabrain couldn't make this. Remove this block, or ${ownAlternative[kind]}.`
      : 'The account that asked for this is out of AI tokens.'
  }
  return "Tunabrain couldn't make this. Remove this block and try again."
}
